/* UNDENIABLE — Fit finder quiz. Reads questions from [data-fit-questions] and sizes from the
   measurements table (data-attributes only — no JSON parsing). Sums answer weights → size index. */
(function () {
  'use strict';
  var $$ = function (s, c) { return [].slice.call((c || document).querySelectorAll(s)); };
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function esc(x) { return (x == null ? '' : String(x)).replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }

  function initFit(root) {
    var host = root.querySelector('[data-fit-quiz]');
    if (!host) return;
    var QS = $$('[data-fit-questions] [data-fit-q]', root).map(function (qel) {
      return {
        q: qel.getAttribute('data-fit-q') || '',
        s: qel.getAttribute('data-fit-sub') || '',
        o: $$('[data-w]', qel).map(function (opt) { return [opt.textContent, +opt.getAttribute('data-w') || 0]; })
      };
    });
    var ths = $$('[data-fit-table] thead th', root);
    var sizes = $$('[data-fit-table] tbody [data-sz]', root).map(function (r) {
      var tds = r.querySelectorAll('td');
      return { n: r.getAttribute('data-sz'), m: [tds[1] ? tds[1].textContent : '', tds[2] ? tds[2].textContent : '', tds[3] ? tds[3].textContent : ''] };
    });
    if (!QS.length || !sizes.length) return;
    var maxIdx = sizes.length - 1;
    var cfg = {
      resultNote: root.getAttribute('data-result-note') || '',
      betweenNote: root.getAttribute('data-between-note') || '',
      shopLabel: root.getAttribute('data-shop-label') || 'Shop size',
      shopUrl: root.getAttribute('data-shop-url') || '/',
      ordersNote: root.getAttribute('data-orders-note') || ''
    };
    var st = { i: 0, a: {} };
    var noteEl = root.querySelector('[data-fit-note]');
    var introNote = noteEl ? noteEl.textContent : '';

    function markRow(name) { $$('[data-fit-table] [data-sz]', root).forEach(function (r) { r.classList.toggle('on', r.getAttribute('data-sz') === name); }); }
    function idxFromSum() { var v = 0; QS.forEach(function (Q, qi) { if (st.a[qi]) v += st.a[qi].w; }); return clamp(v, 0, maxIdx); }
    function hint() { var v = 0, n = 0; QS.forEach(function (Q, qi) { if (st.a[qi]) { v += st.a[qi].w; n++; } }); return n ? ('Leaning ' + sizes[clamp(v, 0, maxIdx)].n) : 'Fit guide'; }
    function col(i) { return ths[i + 1] ? ths[i + 1].textContent : ''; }
    function shopHref(sz) { var u = cfg.shopUrl || '/'; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'filter.v.option.size=' + encodeURIComponent(sz); }

    function render() {
      if (st.i >= QS.length) {
        var sz = sizes[idxFromSum()]; markRow(sz.n);
        if (noteEl) noteEl.textContent = (cfg.resultNote || '').replace('{size}', sz.n);
        var m = sz.m || [];
        host.innerHTML =
          '<div class="sf__bar"><div class="sf__prog"><i style="width:100%"></i></div><div class="sf__step"><span>Complete</span><b>Your size</b></div></div>' +
          '<div class="sfres"><div class="sfres__box"><div><span>Recommended size</span><b>' + esc(sz.n) + '</b></div>' +
          '<a class="btn btn--w" href="' + esc(shopHref(sz.n)) + '">' + esc(cfg.shopLabel) + ' ' + esc(sz.n) + '</a></div>' +
          '<dl class="sfres__m"><div><dt>' + esc(col(0)) + '</dt><dd>' + esc(m[0]) + '</dd></div><div><dt>' + esc(col(1)) + '</dt><dd>' + esc(m[1]) + '</dd></div><div><dt>' + esc(col(2)) + '</dt><dd>' + esc(m[2]) + '</dd></div></dl>' +
          '<p class="p">' + esc(cfg.betweenNote) + '</p>' +
          '<div class="sf__acts"><button class="btn btn--o" data-fit-restart>Start over</button></div></div>';
        return;
      }
      var Q = QS[st.i], cur = st.a[st.i];
      host.innerHTML =
        '<div class="sf__bar"><div class="sf__prog"><i style="width:' + (st.i / QS.length * 100) + '%"></i></div><div class="sf__step"><span>Question ' + (st.i + 1) + ' of ' + QS.length + '</span><b>' + (st.i ? esc(hint()) : 'Fit guide') + '</b></div></div>' +
        '<div class="sfq"><h4>' + esc(Q.q) + '</h4><p>' + esc(Q.s) + '</p><div class="sfopts">' +
        Q.o.map(function (o, i) { return '<button data-fit-o="' + i + '" class="' + (cur && cur.i === i ? 'on' : '') + '">' + esc(o[0]) + '<i>' + (cur && cur.i === i ? 'Selected' : 'Select') + '</i></button>'; }).join('') +
        '</div></div>' +
        '<div class="sf__nav"><button class="sf__back" data-fit-back ' + (st.i ? '' : 'hidden') + '>&larr; Back</button><span class="mn" style="color:var(--g400);font-size:.58rem">' + esc(cfg.ordersNote) + '</span></div>';
    }

    host.addEventListener('click', function (e) {
      var o = e.target.closest('[data-fit-o]');
      if (o) { var Q = QS[st.i], idx = +o.getAttribute('data-fit-o'); st.a[st.i] = { i: idx, w: (Q.o[idx] ? Q.o[idx][1] : 0) }; st.i++; render(); return; }
      if (e.target.closest('[data-fit-back]')) { st.i = Math.max(0, st.i - 1); render(); return; }
      if (e.target.closest('[data-fit-restart]')) { st = { i: 0, a: {} }; markRow(''); if (noteEl) noteEl.textContent = introNote; render(); return; }
    });
    render();
  }

  function boot() { $$('[data-fit]').forEach(function (el) { if (!el._fitInit) { el._fitInit = 1; initFit(el); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
